/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Accordion from 'shared/ui/components/Accordion.vue';
import TargetingControl from 'shared/ui/components/form-components/TargetingControl.vue';

// Mixins
import settingPage from './setting-page';

const __vue_script__ = {
    name: 'Permissions',

    components: {
        Accordion,
        TargetingControl,
    },

    mixins: [settingPage],

    data() {
        return {
            allowExternalInvitees: false,
            allowCreation: true,
            creationPermissions: {
                targets: [],
                exceptions: [],
            },
            arePermissionsVisible: false
        };
    },

    async mounted() {
        this.arePermissionsVisible = this.registry.hasOwnProperty('creation_permissions');
    },

    methods: {
        init() {
            this.allowExternalInvitees = this.settings['allow-external-invitees'];
            this.allowCreation = this.settings['allow_creation'];
            this.creationPermissions = this.settings['creation_permissions'];
        },

        save() {
            this.$emit('save', {
                'allow-external-invitees': this.allowExternalInvitees,
                'allow_creation': this.allowCreation,
                'creation_permissions': this.creationPermissions,
            });
        }
    }

};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "validation-observer",
    {
      ref: "form",
      staticClass: "permissions meta-form",
      attrs: { tag: "form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.save.apply(null, arguments)
        },
      },
    },
    [
      _c("h3", [_vm._v(_vm._s(_vm.$t("meetings.settings.permissions.title")))]),
      _c("accordion", {
        attrs: {
          "headers-i18n-prefix": "meetings.settings.permissions.general",
          "default-open-item": "title",
          animated: true,
          "unlimited-height": true,
          slim: true,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function (ref) {
              return [
                _c("validation-provider", {
                  attrs: { slim: true, name: "allow-external-invitees" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c("meta-control", {
                              attrs: {
                                name: "allow-external-invitees",
                                settings: _vm.settings,
                                control:
                                  _vm.registry["allow-external-invitees"],
                                errors: errors,
                                event: _vm.event,
                              },
                              model: {
                                value: _vm.allowExternalInvitees,
                                callback: function ($$v) {
                                  _vm.allowExternalInvitees = $$v
                                },
                                expression: "allowExternalInvitees",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
        ]),
      }),
      _c("accordion", {
        attrs: {
          "headers-i18n-prefix": "meetings.settings.permissions.meetings",
          "default-open-item": "title",
          animated: true,
          "unlimited-height": true,
          slim: true,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function (ref) {
              return [
                _c("validation-provider", {
                  attrs: { slim: true, name: "allow_creation" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c("meta-control", {
                              attrs: {
                                name: "allow_creation",
                                settings: _vm.settings,
                                control: _vm.registry["allow_creation"],
                                errors: errors,
                                event: _vm.event,
                              },
                              model: {
                                value: _vm.allowCreation,
                                callback: function ($$v) {
                                  _vm.allowCreation = $$v
                                },
                                expression: "allowCreation",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
                _c("validation-provider", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.allowCreation && _vm.arePermissionsVisible,
                      expression: "allowCreation && arePermissionsVisible",
                    },
                  ],
                  attrs: { slim: true, name: "creation_permissions" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (ref) {
                          var errors = ref.errors
                          return [
                            _c("targeting-control", {
                              attrs: {
                                name: "creation_permissions",
                                label:
                                  _vm.registry["creation_permissions"].label,
                                hint: _vm.registry["creation_permissions"].hint,
                                "visible-to-label": _vm.$t(
                                  "meetings.settings.permissions.meetings.targeting.visible_to_label"
                                ),
                                "visible-to-desc": _vm.$t(
                                  "meetings.settings.permissions.meetings.targeting.visible_to_desc"
                                ),
                                "hidden-to-label": _vm.$t(
                                  "meetings.settings.permissions.meetings.targeting.hidden_to_label"
                                ),
                                "hidden-to-desc": _vm.$t(
                                  "meetings.settings.permissions.meetings.targeting.hidden_to_desc"
                                ),
                                "target-label": _vm.$t(
                                  "meetings.settings.permissions.meetings.targeting.target_label"
                                ),
                                errors: errors,
                                eventId: _vm.event._id,
                              },
                              model: {
                                value: _vm.creationPermissions,
                                callback: function ($$v) {
                                  _vm.creationPermissions = $$v
                                },
                                expression: "creationPermissions",
                              },
                            }),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                }),
              ]
            },
          },
        ]),
      }),
      _c("secondary-toolbar", [
        _c(
          "button",
          { staticClass: "btn btn-primary", attrs: { type: "submit" } },
          [_vm._v(_vm._s(_vm.$t("general.save")))]
        ),
      ]),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/backstage/src/ui/components/meetings/sub-pages/Permissions.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__